import { render, staticRenderFns } from "./MyParametricCompare.vue?vue&type=template&id=51ec5b89&"
import script from "./MyParametricCompare.vue?vue&type=script&lang=js&"
export * from "./MyParametricCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports